import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Service } from "../shared/services/service";
import { Funcoes } from "../funcoes";

@Injectable()
export class MercadoInternoMercadoriasService extends Service {

  protected url: string = this.dominio + "/adm/mercado-interno-mercadorias/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

  apagarFoto(id) {
    let headers = this.getHeaderLogado();

    return this.http.delete(this.url + id + '/delete-foto', { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  duplicar(id) {
    let headers = this.getHeaderLogado();

    return this.http.put(this.url + id + '/duplicar', {}, { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/mercado-interno-mercadorias/mercado-interno-mercadorias.service.ts